import { Map } from 'immutable';
import React from 'react';
import Button from '@mui/material/Button';
import GridInput from '../../../components/form/GridInput';
import Section from '../../../components/Section';
import { isValidPassword } from '../../../core/validations/index';
import SplitView from '../../../templates/SplitView';
import Form from '../../../components/Form';

/**
 * Retorna o validador dos campos do formulário
 *
 * @param {*any} data  dados do cliente.
 */
function validator(data) {
  const novaSenha = data.get('novaSenha');
  const confirmacao = data.get('confirmacao');
  let validacaoNovaSenha = '';

  // Avalia a força da senha.
  if (!isValidPassword(novaSenha)) {
    validacaoNovaSenha = 'Senha muito fraca. Tente outra.';
  } else if (!novaSenha) {
    validacaoNovaSenha = 'Digite sua nova senha.';
  }
  const isConfirmacaoDiferente = confirmacao && novaSenha !== confirmacao;

  return Map({
    novaSenha: validacaoNovaSenha,
    confirmacao: isConfirmacaoDiferente ? 'As senhas estão diferentes' : '',
  });
}

/**
 * Retorna o formulário montado.
 */
function ResetPasswordView(props) {
  const { requestProps, formState, resetPassword, view } = props;
  const { cid } = requestProps.match.params;
  return (
    <>
      <SplitView
        title="Mudar senha"
        loading={false}
        contextImage={{
          lg: 6,
          width: 500,
          alt: 'Participe',
          src: '/img/redefinir-senha.svg',
        }}
      >
        <Form view={view} validator={validator}>
          <Section title="Nova Senha" transparent>
            <GridInput
              name="novaSenha"
              label="Senha nova"
              type="password"
              variant="outlined"
              required
            />
            <GridInput
              name="confirmacao"
              label="Confirmação da senha nova"
              type="password"
              variant="outlined"
              required
            />
            <div style={{ display: 'flex', width: '100%' }}>
              <Button
                variant="contained"
                color="primary"
                style={{ margin: '8px auto', padding: '8px 24px' }}
                onClick={() => resetPassword(formState, cid)}
              >
                <b>Redefinir</b>
              </Button>
            </div>
          </Section>
        </Form>
      </SplitView>
    </>
  );
}

export default ResetPasswordView;
